'use strict';

/*global Container */
/*global Cookies */
/*global Translator */
/*global Configurations*/
/*global K2Modal */
/*global K2Confirm */
/*global Router*/
/*global Notifications*/
/*global K2Keyboard*/
/*global K2KeyboardFormController*/
/*global K2LoginKeyboard*/
/*global K2PrinterSetting*/
/*global K2AboutApp*/
/*global K2Logging*/
/*global K2UserAdditionalLogin*/
/*global KeyShortcutsManager*/
/*global InputService*/
/*global SelectSevice*/
/*global OutputService*/
/*global ConfirmService*/
/*global StopwatchesService*/
/*global BarcodeService*/
/*global BarcodeCheckService*/
/*global ArticleService*/
/*global TransferNoteService*/
/*global ReleaseNoteService*/
/*global HandlingUnitService*/
/*global JobCardService*/
/*global JobCardSearchService*/
/*global JobCardSearchItemService*/
/*global WarehouseService*/
/*global ProductionService*/
/*global ProductionTimingService*/
/*global ReasonService*/
/*global K2FormationViewer*/

/*exported services*/
var services = new Container();

$(document).ready(function () {
  services.set('translator', new Translator('k2_translations'));
  services.set('cookies', new Cookies());
  services.set('configurations', new Configurations('k2_configurations'));
  services.set('key-shortcuts-manager', new KeyShortcutsManager());

  services.set('logging', new K2Logging());

  services.set('modal-job-card', new K2Modal('k2-modal-job-card'));
  services.set('modal-transfer-note', new K2Modal('k2-modal-transfer-note'));
  services.set('modal-release-note', new K2Modal('k2-modal-release-note'));
  services.set('modal-warehouse', new K2Modal('k2-modal-warehouse'));
  services.set('modal', new K2Modal('k2-modal'));
  services.set('modal-user-additional-login', new K2Modal('k2-modal-user-additional-login'));
  services.set('modal-input', new K2Modal('k2-modal-input'));
  services.set('modal-output', new K2Modal('k2-modal-output'));
  services.set('modal-lookup', new K2Modal('k2-modal-lookup'));
  services.set('modal-keyboard', new K2Modal('k2-modal-keyboard'));
  services.set('modal-image', new K2Modal('k2-modal-image'));
  services.set('modal-formation-viewer', new K2Modal('k2-modal-formation-viewer'));
  services.set('modal-notifications', new K2Modal('k2-modal-notifications'));

  services.set('confirm', new K2Confirm('k2-confirm'));
  services.set('confirm-second', new K2Confirm('k2-confirm-second'));

  services.set('router', new Router('k2_paths'));
  services.set('notifications', new Notifications());

  services.set('keyboard', new K2Keyboard());
  services.set('keyboard-form-controller', new K2KeyboardFormController());
  services.set('login-keyboard', new K2LoginKeyboard());

  services.set('about-app', new K2AboutApp());
  services.set('printer-setting', new K2PrinterSetting());

  services.set('input-service', new InputService());
  services.set('select-service', new SelectSevice());
  services.set('output-service', new OutputService());
  services.set('confirm-service', new ConfirmService());

  services.set('stopwatches', new StopwatchesService());
  services.set('barcode', new BarcodeService());
  services.set('barcode-check', new BarcodeCheckService());
  services.set('article', new ArticleService());
  services.set('transfer-note', new TransferNoteService());
  services.set('release-note', new ReleaseNoteService());
  services.set('handling-unit', new HandlingUnitService());
  services.set('job-card', new JobCardService());
  services.set('job-card-search', new JobCardSearchService());
  services.set('job-card-search-item', new JobCardSearchItemService());
  services.set('warehouse', new WarehouseService());
  services.set('production', new ProductionService());
  services.set('production-timing', new ProductionTimingService());
  services.set('reason', new ReasonService());

  services.set('formation-viewer', new K2FormationViewer(services.get('modal-formation-viewer')));
  services.set('user-additional-login', new K2UserAdditionalLogin(services.get('modal-user-additional-login')));

  //services.set('main-page-module', ...); //hlavni modul stranky, ktery lze volat napriklad z K2Location ... nutne dle potreby nastavit
});
